<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'政策指引管理'},{name:'政策申报列表'}]" :title="'政策申报列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">上架状态</span>
                        <el-select v-model="sendInfoOne.status" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in uaList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">发布日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="政策申报ID">
                </el-table-column>
                <el-table-column
                    prop="policyName"
                    show-overflow-tooltip
                    
                    width="400"
                    label="政策申报名称">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    
                    label="上架状态">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="发布时间">
                </el-table-column>
                <el-table-column prop="viewNum" sortable="custom" show-overflow-tooltip  label="浏览数"></el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:policy:declare:list:button:view') != -1 || authorities.indexOf('sys:permission:background:policy:declare:list:button:status') != -1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:policy:declare:list:button:view') != -1" @click="check(scope.row)">查看</el-button>
                        <el-button size="small" :type="scope.row.btnValue === '上架'?'success':'warning'" class="super" plain :disabled="scope.row.isEditable == 1" v-if="authorities.indexOf('sys:permission:background:policy:declare:list:button:status') != -1" @click="soldOut(scope.row)">{{scope.row.btnValue}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
        </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
// import breadcrumb from '../../components/breadcrumb';
import {getDict} from "@/axios";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
             options: [{
                value: '2',
                label: '政策申报名称'
                }, {
                value: '3',
                label: '发布账号'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                status:'',//上架状态
                id:"",//申请id
                policyName:'',//政策申报名称
                userName:"",//发布账号
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            uaList:[],
            tableData:[],//表格数据
            currentPage:1,//当前页
            totalSize:null
        }
    },
    mounted(){
        const that = this
        // 审核结果
        getDict('UA_LS').then(data=>{
            that.uaList = data.UA_LS
        })
        // 请求
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    },
    methods:{
      onReset(){
        const params = {
          currentPage:1,//当前页
                pageSize:10,//页条数
                endDate:'',//结束时间
                startDate:'',//开始时间
                status:'',//上架状态
                id:"",//申请id
                policyName:'',//政策申报名称
                userName:"",//发布账号
                property:null,//排序字段
                direction:null,//排序方式
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,params)
        this.getSelect = void 0
        this.getValue = void 0
        this.dateS = []
        this.getData()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        getData(){
            this.loading = true
            if(this.dateS&&this.dateS.length>0){
                this.sendInfoOne.startDate=this.dateS[0];
                this.sendInfoOne.endDate=this.dateS[1];
            }else{
                this.sendInfoOne.startDate=null;
                this.sendInfoOne.endDate=null;
            }
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.policyName='';//政策资讯标题
            this.sendInfoOne.userName='';//发布账号
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.policyName=this.getValue;
            }else if(this.getSelect=='3'){ //姓名
                this.sendInfoOne.userName=this.getValue;
            }
            this.$axiosc.get('backstage/policy/declare/all/list',{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code==200){
                    this.tableData=res.data.content;
                    this.totalSize=res.data.totalElements;
                }else{
                    this.$alert(res.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        },
        //表格排序
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:'/policyManagement/declareDetail',query:{id:row.id,index:'/policyManagement/declare'}})
        },
        getList(id,btnValue){
            this.$axiosc.put('backstage/policy/declare/shelfObtained/'+id).then(res=>{
                if(res.code == 200){
                    this.getData()
                    this.$message({
                        type: 'success',
                        message: btnValue+'成功!'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg,
                    });
                }
            })
        },
        //表格下架,上架按钮
        soldOut:function(row){
            let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.getList(row.id,btnValue)
                }).catch(() => {    
            });
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
    }
}
</script>